import React, { useState, useEffect, useCallback } from 'react';
import { getSettings, updateSettings } from '../api';
import './SettingsPage.css';

function SettingsPage() {
  // Состояния
  const [settings, setSettings] = useState({
    verbose_ai_logging: false
  });
  const [fullSettings, setFullSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Загрузка настроек при монтировании
  const fetchSettings = useCallback(async () => {
    setLoading(true);
    setError('');
    
    try {
      const result = await getSettings();
      setFullSettings(result);
      setSettings(prev => ({
        ...prev,
        verbose_ai_logging: result.verbose_ai_logging || false
      }));
    } catch (err) {
      setError('Ошибка загрузки настроек: ' + (err.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  // Изменение чекбокса
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: checked
    }));
    setSuccess('');
    setError('');
  };

  // Сохранение настроек
  const handleSave = async () => {
    setSaving(true);
    setError('');
    setSuccess('');
    
    try {
      await updateSettings({ ...fullSettings, ...settings });
      setSuccess('Настройки сохранены');
    } catch (err) {
      setError('Ошибка сохранения: ' + (err.message || 'Unknown error'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="settings-page">
      <div className="page-header">
        <h1>⚙️ Настройки</h1>
        <div className="page-header-actions">
          <button className="secondary" onClick={fetchSettings} disabled={loading}>
            Обновить
          </button>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}

      {loading ? (
        <div className="loading">Загрузка настроек</div>
      ) : (
        <div className="settings-content">
          <div className="settings-section card">
            <h2>Логгирование</h2>
            <p className="section-description">
              Настройки детализации логов для отладки ИИ-запросов
            </p>
            
            <div className="settings-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="verbose_ai_logging"
                  checked={settings.verbose_ai_logging}
                  onChange={handleCheckboxChange}
                  disabled={saving}
                />
                <span className="checkbox-text">
                  Детальное логгирование ИИ-запросов
                </span>
              </label>
              <p className="field-hint">
                При включении в консоль сервера выводятся этапы обработки: 
                формирование промптов, отправка запроса, получение ответа.
              </p>
            </div>
          </div>

          <div className="settings-actions">
            <button 
              className="primary" 
              onClick={handleSave} 
              disabled={saving || loading}
            >
              {saving ? 'Сохранение...' : 'Сохранить'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SettingsPage;